export class LoanSellerAdjustmentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAdjustments({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/seller-adjustments`);
  }

  async editAdjustments({ applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/seller-adjustments`, body);
  }
}
